const Form100EN = {
    stepName: {
        importantNotes: "Important Notes",
        selectType: "Selection of Type(s)",
        schoolInformation: "Information of the School",
        applicantBodyInformation: "Information of School Sponsoring Body (SSB)",
        eligibilityRequirement: "Eligibility Requirement",
        locationPreference: "Location Preference",
        documentUpload: "Document upload",
        successfulObligations:
            "Obligations of the Successful School Sponsoring Body (SSB)",
        confirmation: "Confirmation",
    },
    label: {
        year: "Year:",
        yearPage: "Year",
        type: "Type of exercise:",
        typeOptions: {
            A: "Reprovisioning of Primary School(s)",
            B: "Reprovisioning of Secondary School(s)",
            C: "Reprovisioning of Primary and Secondary School(s)",
            D: "Operating a Special School",
            E: "Operating a Special School with Boarding Facilities",
            F: "Physical Extension of Primary/Secondary School(s) for a Time-Limited Period",
            G: "Operation of New Time-Limited Primary/Secondary School",
            H: "Operation of New Primary/Secondary School",
            I: "Physical Extension of an Existing Primary/Secondary School",
        },
        exercisePeriod: "Exercise period:",
        to: "To:",
        no: "No:",
        title: "Form Title:",
        districtTitle: "District in title:",
        itemNo: "Item no.:",
        location: "Location:",
        addExercise: "ADD EXERCISE",
        declaration:
            "I have read the “Personal Information Collection Statement” and fully understand its content.",
        exerciseType: "Type of School Allocation Exercise",
        districtOrPlace: "District/Place",
        noInPdfTitle: "No. of SAE in the year",
        copies: "Copies",
        pages: "Pages",
        noInEformTitle: "No. in eform title",
        noOfPremisesAvailable: "No. of premises available:",
        pdfLink: "Link to view latest obligation pdf:",
        schoolNameEn: "Full Name of the School (English)",
        schoolNameCn: "Full Name of the School (Chinese)",
        schoolAddressEn: "Full Address of the School (English)",
        schoolAddressCn: "Full Address of the School (Chinese)",
        financeType: "Finance Type",
        applicantBodyEn:
            "Registered Name of the School Sponsoring Body (SSB) (English)",
        applicantBodyCn:
            "Registered Name of the School Sponsoring Body (SSB) (Chinese)",
        correspondenceAddressEn: "Correspondence Address (English)",
        correspondenceAddressCn: "Correspondence Address (Chinese)",
        titleEn: "Title (English)",
        titleCn: "Title (Chinese)",
        contactNameEn: "Name of Contact Person (English)",
        contactNameCn: "Name of Contact Person (Chinese)",
        positionEn: "Position (English)",
        positionCn: "Position (Chinese)",
        telNo: "Telephone No",
        faxNo: "Fax No",
        email: "Email Address",
        contactPersonInformation: "Contact Person Information",
        isRegisteredOrdinance:
            "Is the School Sponsoring Body (SSB) registered under the Companies Ordinance (Cap 622)?",
        specifyOrdinance:
            "Please specify under which Ordinance the School Sponsoring Body (SSB) is incorporated in Hong Kong",
        isExemptOrdinance:
            "Is the School Sponsoring Body (SSB) exempt from tax under Section 88 of the Inland Revenue Ordinance (Cap 112)?",
        yesOrNo: {
            yes: "Yes",
            no: "No",
        },
        indicatePreference:
            "Please indicate the preference for the locations below—",
        locationSelectType: "Category",
        locationItemNo: "Site/Premises No.",
        locationLocation: "Location",
        locationItemNoAndLocation: "Site/Premises No. and Location",
        locationPriority: "Priority",
        documentsChecklist: "Checklist on the documents required",
        allocatedCommitted:
            "If the School Sponsoring Body (SSB) is allocated a school premises, it will be committed to:",
        allocatedCommittedNote: {
            a: "Implementing education initiatives promoted by the Education Bureau (“EDB”)",
            b: "Returning its existing school premises. Where the existing site of the school is located within a private lot under the ownership of the SSB, the school or a third party related to the SSB/ school, the SSB will be committed to ensure that upon allocation of the new premises to the SSB, the existing site of the school together with all buildings and structures thereon shall be surrendered to the Government free from encumbrances and any claims, actions, proceedings, and liabilities whether by way of adverse possession or otherwise, and free of cost and compensation; and",
            c: "Within the required timeframes set by the Government, signing a tenancy agreement for use of the school premises and service agreement(s) which will serve to facilitate quality control and to ensure compliance with relevant education policies.",
        },
        allocatedCommittedCheckText:
            "I acknowledge that I have read, understood and agreed to abide by obligations stated above",
        EDBDeclaration: "Declaration on the part of EDB",
        applicationNature: "Non-binding Nature of Application",
        EDBDeclarationText:
            "The invitation for application and submission of detailed school proposal is non-binding by nature. It does not constitute any kind of offer or the basis of any kind of offer to any party for school allocation, nor does it create any legal obligations on the Government. It does not prejudice any future scrutiny by the School Allocation Committee/ Government, nor commit them to any course of action including whether or not to approve any allocation at all, irrespective of the number of applications received. Nothing in this invitation shall oblige the Government to allocate the premises to any party at any time.",
        responsiblePerson:
            "Responsible Person of the School Sponsoring Body (SSB)",
        responsiblePersonNameEn:
            "Name of Responsible Person of the School Sponsoring Body (SSB) (English)",
        responsiblePersonNameCn:
            "Name of Responsible Person of the School Sponsoring Body (SSB) (Chinese)",
        responsiblePersonPosition: "Position",
        responsiblePersonOrganisation: "Organisation",
        obligationLink: "Link to view latest obligation pdf",
        titleEnOp: {
            Mr: "Mr",
            Mrs: "Mrs",
            Ms: "Ms",
            Miss: "Miss",
        },
        titleCnOp: {
            Mr: "先生",
            Mrs: "太太",
            Ms: "女士",
            Miss: "小姐",
        },
        financeTypeOp: {
            Aided: "Aided",
            Caput: "Caput",
            Direct: "Direct Subsidy Scheme",
            Private: "Private",
            Others: "Others",
        },
        otherRemark: "Please specify",
        eligibleSchoolType: "Eligible Type of School",
        allocationType: "Allocation type",
        allocationTypeOp: {
            Premises: "School Premises",
            Site: "School Site",
        },
        allocationNo: "School Allocation Exercise Number",
    },
    documentsChecklistMsg: {
        one: "1. <u>If the School Sponsoring Body (SSB) is incorporated under the Companies Ordinance</u>, please provide its incorporation document and Articles of Association and complete and return ",
        oneA: "Annex I",
        oneB: " of this Application form.",
        two: "2. <u>If the School Sponsoring Body (SSB) is incorporated under its own Ordinance</u>, please provide the content of the relevant Ordinance, and its Constitution, if any.",
        three: "3. School Sponsoring Body (SSB)’s certificate of exemption from tax.",
        four: "4. Upload soft copies of each of the following documents:",
        fourA: "(i) the proposed school plan (NOT more than {{pages}} pages",
        fourB: " including all annexes), (ii) the executive summary (NOT more than two pages",
        fourC: ") and (iii) list of operating schools run by the School Sponsoring Body (SSB), if any (please list the names, addresses and types of schools).",
        five: "5. I understand that I need to submit {{copies}} physical copies each of the following documents to EDB:",
        fiveA: "(i) the proposed school plan (NOT more than {{pages}} pages<sup>#</sup> including all annexes), (ii) the executive summary (NOT more than two pages<sup>#</sup>) and (iii) list of operating schools run by the School Sponsoring Body (SSB), if any (please list the names, addresses and types of schools).",
        six: "6. Survey form on existing school’s facilities, conditions, land/ building status, class structure and enrolment situation (",
        sixA: "Annex II",
        sixB: " of this Application Form).",
        seven: "7. Survey form on existing school’s class structure and enrolment situation (",
        sevenA: "Annex II",
        sevenB: " of this Application Form).",
        eight: "8. Details of ownership and ownership record, including but not limited to title deeds, land/tenancy agreements with plans, latest ownership records certified correct by the Land Registry, writ, summons, charging order, notice or order of the Government or other competent authority, etc. (only applicable if the school is currently located within a private lot under the ownership of the SSB, the school or a third party related to the SSB/ school) (only applicable to applications for reprovisioning of existing schools).",
        nine: "9. Documentary proof that parents and teachers have been consulted on reprovisioning/ physical extension (whichever applicable) of the school and their views about the reprovisioning/ physical extension (whichever applicable). Please also provide information indicating the scale/ type of the consultation, e.g. number of questionnaires issued and received, etc.",
    },
    tooltipMsg: {
        schoolInformation:
            "The application must be submitted by the registered school sponsoring body of the applicant school.",
        applicantBodyInformation:
            "The school sponsoring body must be the registered school sponsoring body for the applicant school meeting the eligibility requirement.",
        eligibilityRequirement:
            "Please note the eligibility requirements of the SSBs as set out in Item 1 of the Guidance Notes.",
        locationPriority:
            "Please indicate the location preference with “1” being the “most wanted”. A maximum of {{premisesAvailable}} and a minimum of 1 choice(s) could be made. All applications are subject to scrutiny by the School Allocation Committee, and priorities indicated by the SSBs will be taken into account. Application without filling in the priority box or not indicating any explicit preference may not be processed further. The Government is not obliged to allocated any premises to any party or follow the priorities indicated by the SSBs.",
        documentsChecklist:
            "Content in pages exceeding the page limited would not be considered",
    },
    errorMsg: {
        repeatData: "Please enter non duplicate {{item}}",
    },
    expiredMessage:
        "No School Allocation Exercise is open for application at the moment.  For updates on School Allocation Exercise, please check our webpage:",
    tips: {
        note: "Please read the Guidance Notes before completing this form.",
        noteTwo:
            "Please click the “ADD” button if the School Sponsoring Body wishes to apply for more than one school premises/school sites (whichever applicable).",
    },
};

export default Form100EN;
